export enum UserTypeEnum {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  CUSTOMER = 'CUSTOMER',
}

export type UserFilter = {
  name: string
  username: string
  genders: string[]
  phone: string
  userTypes: UserTypeEntity[]
}

export type UserTypeEntity = {
  id: number
  type: UserTypeEnum
}

export type UserEntity = {
  id: number
  name: string
  address: string
  phone: string
  username: string
  email?: string
  identityCardNumber: string
  gender: boolean
  dateOfBirth: number
  note?: string
  userType: UserTypeEntity
}
